import React from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Title } from 'smartsuite-ui';

function getIsDraggingOverClassName(isDraggingOver) {
    return isDraggingOver
        ? 'column-config__droppable column-config__droppable--is-dragging-over'
        : 'column-config__droppable';
}

function getDraggingClassName(isDragging) {
    return isDragging
        ? 'column-config__draggable column-config__draggable--is-dragging'
        : 'column-config__draggable';
}

export default function ColumnConfigSection(props) {
    return (
        <div className="column-config">
            <Title cssClassModifiers={['size-small']}>{props.title}</Title>
            <Droppable droppableId={props.droppableId}>
                {(dropProvided, dropSnapshot) => (
                    <div
                        className={getIsDraggingOverClassName(
                            dropSnapshot.isDraggingOver
                        )}
                        {...dropProvided.droppableProps}
                        ref={dropProvided.innerRef}
                    >
                        {props.columns.map((column, index) => (
                            <Draggable
                                key={column.dataKey}
                                draggableId={column.dataKey}
                                index={index}
                            >
                                {(dragprovided, dragSnapshot) => (
                                    <div
                                        className={getDraggingClassName(
                                            dragSnapshot.isDragging
                                        )}
                                        ref={dragprovided.innerRef}
                                        {...dragprovided.draggableProps}
                                        {...dragprovided.dragHandleProps}
                                    >
                                        {column.dataKey}
                                    </div>
                                )}
                            </Draggable>
                        ))}

                        {dropProvided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
}

ColumnConfigSection.propTypes = {
    columns: PropTypes.instanceOf(Array).isRequired,
    droppableId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
